import * as React from 'react';

import { Link } from '../../../Link';
import { IBuildingsStatusInfo } from '../../../../types/newbuilding';
import * as styles from './BuilderStats.css';
import { UIText2 } from '@cian/ui-kit';

interface IBuilderStatsProps {
  stats: IBuildingsStatusInfo;
}

export const BuilderStats: React.VFC<IBuilderStatsProps> = ({ stats }) => {
  const { finished, inProgress } = stats;

  return (
    <ul className={styles['stats']} data-testid="BuilderStats">
      {finished && (
        <li className={styles['stats-item']} data-testid="BuilderStatsItem">
          <UIText2 color="text-secondary-default">
            Сдано{' '}
            <Link href={finished.url} target="_blank">
              {finished.count} ЖК
            </Link>
          </UIText2>
        </li>
      )}
      {inProgress && (
        <li className={styles['stats-item']} data-testid="BuilderStatsItem">
          <UIText2 color="text-secondary-default">
            Строится{' '}
            <Link href={inProgress.url} target="_blank">
              {inProgress.count} ЖК
            </Link>
          </UIText2>
        </li>
      )}
    </ul>
  );
};
